<template>
  <v-footer color="transparent" padless class="te-footer-wrap">
    <div class="te-footer-surface">
      <v-container class="footer py-10 py-md-12">
        <div class="footer__brand">
          <div class="d-flex align-center mb-4">
            <div class="footer__logo-mark primary" />
            <div class="ml-3">
              <div class="footer__name primary--text">TOEATO</div>
              <div class="footer__tagline">Food delivery, simplified.</div>
            </div>
          </div>
          <p class="footer__blurb mb-4">
            Order from local favourites across Nepal. Fast delivery and a clean
            app experience built for everyday cravings.
          </p>
          <v-btn
            color="primary"
            depressed
            class="mb-4"
            target="_blank"
            href="https://play.google.com/store/apps/details?id=com.toeato.toeato"
          >
            <v-icon left small>mdi-google-play</v-icon>
            Google Play
          </v-btn>
          <div class="d-flex align-center flex-wrap" style="gap: 8px">
            <span class="footer__label">Follow</span>
            <v-btn
              v-for="(social, s) in socials"
              :key="s"
              icon
              small
              outlined
              color="secondary"
              class="footer__social"
              target="_blank"
              :href="social.to"
            >
              <v-icon small :color="social.color">{{ social.icon }}</v-icon>
            </v-btn>
          </div>
        </div>

        <div class="footer__grid">
          <div class="footer__col">
            <div class="footer__title">Explore</div>
            <router-link
              v-for="(inf, i) in info"
              :key="i"
              class="footer__link"
              :to="inf.route"
            >
              {{ inf.title }}
            </router-link>
          </div>
          <div class="footer__col">
            <div class="footer__title">Contact</div>
            <div v-for="(con, c) in contact" :key="c" class="footer__line">
              {{ con }}
            </div>
          </div>
        </div>
      </v-container>
      <v-divider class="mx-4 mx-sm-6" />
      <v-container class="py-4 d-flex flex-wrap align-center justify-space-between">
        <span class="footer__copyright">
          © {{ year }} Toeato Pvt. Ltd. All rights reserved.
        </span>
        <router-link class="footer__mini-link" to="/privacy-policy">
          Privacy
        </router-link>
      </v-container>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: "index-footer",
  data: () => ({
    year: new Date().getFullYear(),
    info: [
      { title: "Home", route: "/" },
      { title: "About", route: "/about" },
      { title: "Contact", route: "/contact" },
      { title: "Careers", route: "/careers" },
      { title: "Delete account", route: "/delete_account" },
      { title: "Privacy policy", route: "/privacy-policy" },
    ],
    contact: ["Birgunj-10, Nepal", "toeato1@gmail.com", "+977 9814245916"],
  }),
};
</script>

<style scoped lang="scss">
@import "../styles/tokens";

.te-footer-wrap {
  margin-top: auto;
  width: 100% !important;
  left: 0;
  right: 0;
}

.te-footer-surface {
  background: $te-surface;
  border-top: 1px solid $te-border;
  box-shadow: 0 -4px 24px rgba(15, 23, 42, 0.04);
  width: 100%;
}

.footer {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
  gap: 48px;
  align-items: start;
}

.footer__logo-mark {
  width: 44px;
  height: 44px;
  border-radius: $te-radius-sm;
  opacity: 0.9;
}

.footer__name {
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 1.2;
}

.footer__tagline {
  font-size: $te-font-body-sm;
  color: $te-text-muted;
  margin-top: 2px;
}

.footer__blurb {
  font-size: $te-font-body-sm;
  line-height: 1.55;
  color: $te-text-muted;
  max-width: 360px;
}

.footer__label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: $te-text-muted;
  margin-right: 4px;
}

.footer__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 32px 24px;
}

.footer__title {
  font-size: 14px;
  font-weight: 700;
  color: $te-text;
  margin-bottom: 14px;
  letter-spacing: 0.02em;
}

.footer__link {
  display: block;
  font-size: $te-font-body-sm;
  color: $te-text-muted;
  text-decoration: none;
  padding: 6px 0;
  transition: color 0.15s ease;
}

.footer__link:hover {
  color: $te-primary;
}

.footer__line {
  font-size: $te-font-body-sm;
  color: $te-text-muted;
  line-height: 1.5;
  margin-bottom: 6px;
}

.footer__copyright,
.footer__mini-link {
  font-size: $te-font-caption;
  color: $te-text-muted;
}

.footer__mini-link {
  text-decoration: none;
  font-weight: 500;
}

.footer__mini-link:hover {
  color: $te-primary;
}

@media (max-width: 960px) {
  .footer {
    grid-template-columns: 1fr;
    gap: 36px;
  }
}

@media (max-width: 600px) {
  .footer__grid {
    grid-template-columns: 1fr;
  }
}
</style>
